module.exports = __webpack_public_path__ + "398de06fac9708b70f270bc258ddc5ad.svg";